import { BATCH_TAG_WIZARD_STEP } from './constants'

/** 各向导页标题，用于弹窗标题后缀「批量打标 · …」 */
export const WIZARD_PAGE_TITLES = {
  [BATCH_TAG_WIZARD_STEP.SCOPE]: '选择资源',
  [BATCH_TAG_WIZARD_STEP.METHOD]: '选择打标方式',
  [BATCH_TAG_WIZARD_STEP.PAGE_TAG]: '页面打标',
  [BATCH_TAG_WIZARD_STEP.EXCEL_TAG]: 'Excel 打标',
}

/** 各页使用说明：在弹窗顶部说明显示屏轮播，不在正文重复 */
export const WIZARD_PAGE_USAGE = {
  [BATCH_TAG_WIZARD_STEP.SCOPE]: [
    '勾选要打标的资源；从列表进入时，已勾选项会自动带入',
    '可按资源名称、类型筛选下方列表，勾选结果会跨页累积',
    '若已离线改好打标表，可点底部「已有打标表？直接上传」进入 Excel 打标页',
    '直接上传须先选择更新模式，再上传 Excel；作用范围由表内 key 自证',
    '勾选资源后点底部「下一步（N）」进入打标方式选择',
  ],
  [BATCH_TAG_WIZARD_STEP.METHOD]: [
    '页面打标：在页面上选择 Tag，适合少量、需逐条核对',
    'Excel 打标：导出打标表填写 Tag 列后上传，适合批量修改',
    '两种方式均支持追加、覆盖、移除三种更新模式',
    '已有改好的打标表？可在第 1 步底部直接上传，无需勾选资源',
  ],
  [BATCH_TAG_WIZARD_STEP.PAGE_TAG]: [
    '先选择更新模式，再在下方选择要打上的 Tag',
    '点击上方「已选 Tag」可展开查看或移除',
    '底部「变更预览」可查看每条资源的 Tag diff',
    '确认无误后点「确认打标」提交',
  ],
  [BATCH_TAG_WIZARD_STEP.EXCEL_TAG]: [
    '先选择更新模式（追加 / 覆盖 / 移除），再导出或上传对应打标表',
    '不确定 Tag 名称？可先「下载 Tag 名录」对照；操作列须填已存在的 Tag 名',
    '表含：资源名称、类型、key、当前 Tag（参考，多行只读）、以及本模式操作列',
    '覆盖模式：操作列预填当前 Tag，可直接修改；留空表示清空全部 Tag',
    '追加 / 移除模式：仅填写操作列，多个 Tag 用逗号分隔；空行表示本资源无变更',
    '导出后可关窗离线修改；回来可「直接上传」或恢复上次草稿，无需重选资源',
    '上传时会校验表头、Tag 名称与 key 范围；不匹配请重新导出或切换模式',
  ],
}

/** 第 2 层：页面 / Excel 打标方式卡片文案 */
export const METHOD_PICKER_OPTIONS = [
  {
    value: 'page',
    icon: 'el-icon-price-tag',
    title: '页面打标',
    desc: '在页面上选择 Tag，适合少量、需要逐条核对的资源。',
    hint: '支持追加、覆盖、移除',
  },
  {
    value: 'excel',
    icon: 'el-icon-document',
    title: 'Excel 打标',
    desc: '先选更新模式，导出打标表并填写对应操作列后上传，适合批量修改。',
    hint: '模板含 key 列，界面不展示',
  },
]

/** @deprecated 兼容旧引用，请改用 WIZARD_PAGE_USAGE */
export const DIALOG_USAGE_LINES = WIZARD_PAGE_USAGE[BATCH_TAG_WIZARD_STEP.SCOPE]

/** @deprecated 已并入 WIZARD_PAGE_USAGE[EXCEL_TAG] */
export const EXCEL_COLUMN_TIPS = []
export const EXCEL_UPLOAD_TIPS = []

/**
 * 按向导步骤返回当前页帮助内容（仅使用说明，不含 FAQ）。
 */
export function getWizardPageHelp(wizardStep) {
  const title = WIZARD_PAGE_TITLES[wizardStep] || '批量打标'
  const lines = WIZARD_PAGE_USAGE[wizardStep] || []
  return { title, lines }
}

/** 批量打标说明轮播：与列表控制条显示屏同款交互 */
export const BATCH_TAG_HELP_CAROUSEL = {
  pauseOnHover: true,
  defaultDwellMs: 3500,
}

/**
 * 选择资源页：左侧固定范围文案（不进入轮播）。
 */
export function buildPickerScopeLabel({ hasFilters, filterSummary, totalCount }) {
  const scopePart = hasFilters ? `当前范围：${filterSummary}` : '全部资源'
  const countPart = totalCount >= 0 ? ` · 共 ${totalCount} 条可选` : ''
  return `${scopePart}${countPart}`
}

/** @deprecated 范围信息已固定在左侧，不再作为轮播帧 */
export function buildPickerScopeCarouselSlide(options) {
  return {
    id: 'scope-picker-range',
    type: 'scope-default',
    enabled: true,
    dwellMs: 4000,
    label: buildPickerScopeLabel(options),
  }
}

/**
 * 将当前步骤的使用说明转为 ControlBarCarousel 播片列表。
 */
export function buildWizardHelpCarouselSlides(wizardStep) {
  const { title, lines } = getWizardPageHelp(wizardStep)

  return lines.map((line, index) => ({
    id: `${wizardStep}-usage-${index}`,
    type: 'release-note',
    enabled: true,
    dwellMs: BATCH_TAG_HELP_CAROUSEL.defaultDwellMs,
    title,
    summary: line,
  }))
}
